import script from "./dol-list-button.vue?vue&type=script&lang=js"
export * from "./dol-list-button.vue?vue&type=script&lang=js"

import "./dol-list-button.vue?vue&type=style&index=0&id=1f195072&lang=scss"

const __exports__ = script;

export default __exports__